"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var makeStyles_1 = require("@material-ui/core/styles/makeStyles");
var objectFieldTemplateStyles = makeStyles_1.default(function () { return ({
    root: {
        padding: '0 10px',
        flexBasis: 'initial',
    },
    child: {
        padding: '0 15px',
        marginBottom: 25,
    },
    singleField: {
        padding: '0 25px',
        marginBottom: '20px',
    },
}); }, { name: 'Checkout_objectFieldTemplate' });
exports.default = objectFieldTemplateStyles;
